import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import MainLayout from "../../layout";
import FormTextField from "../../components/form/text";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toast/successToast";
import errorToast from "../../components/toast/errorToast";
import { useEffect, useState } from "react";
import { api } from "../../redux/apis/api";

const EditDepartment = () => {
  const naviagte = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();

  const initialValues = {
    id: params?.id,
    name: data?.name ?? "",
  };

  const validationSchema = Yup.object().shape({
    name: Yup.string().required("Required"),
  });

  const handleSubmit = (values) => {
    api
      .post(`/department/edit`, values)
      .then((response) => {
        successToast(response.message);
        naviagte(`/department/list`);
      })
      .catch((error) => {
        console.error("API Error:", error);
        errorToast(error?.response?.data?.message);
      });
  };

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/department/read`, {
        id: params?.id,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <MainLayout>
      <section className="h-full overflow-auto md:px-3">
        {loading ? (
          <div className="h-full flex justify-center items-center">
            <div>
              <div className="animate-spin rounded-full h-10 w-10 border-4 border-primary border-t-transparent mx-2"></div>
              <p className="mt-2 text-sm text-gray-500">Loading...</p>
            </div>
          </div>
        ) : (
          <>
            <Formik
              initialValues={initialValues}
              validationSchema={validationSchema}
              onSubmit={handleSubmit}
              enableReinitialize={true}
            >
              {({ values }) => (
                <Form>
                  <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
                    <h2 className="text-xl font-semibold capitalize">
                      department - Edit
                    </h2>
                    <div className="flex gap-3 items-center">
                      <button
                        onClick={() => naviagte("/department/list")}
                        type="button"
                        className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                      >
                        Save
                      </button>
                    </div>
                  </div>

                  <section className="w-full max-w-[40rem]">
                    <div className="my-4">
                      <FormTextField
                        name={"name"}
                        label={"name"}
                        placeholder={`Enter your name`}
                        value={values?.name}
                      />
                    </div>
                  </section>
                </Form>
              )}
            </Formik>
          </>
        )}
      </section>
    </MainLayout>
  );
};

export default EditDepartment;
